import { Avatar } from "@mantine/core"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"
import { useGetAuthenticatedUser } from "../../app/-components/use-authenticated-user"
import { ChatIcon } from "./ChatIcon"
import { PersonProfilePictureAvatar } from "../../app/-components/person-profile-picture-avatar"
import { ChatDto } from "@/orval/gen/model"

interface Props {
  chat: ChatDto
}

export function ChatAvatar({ chat }: Props) {
  const { data: authenticatedUser } = useGetAuthenticatedUser()
  const { data: user } = useSuspenseQueryGet("/api/User/GetSimpleUser", {
    includePerson: true,
    userId:
      chat.chatMembers.find((cm) => cm.userId !== authenticatedUser.userId)
        ?.userId ?? 0,
  })

  return chat.chatType === "Direct" ? (
    <PersonProfilePictureAvatar
      personId={user.person?.personId ?? 0}
      name={user.person?.name}
    />
  ) : (
    <Avatar>
      <ChatIcon chatType={chat.chatType} />
    </Avatar>
  )
}
